import * as React from 'react';
import styles from './SharePointOrganizer.module.scss';
import type { IHealthReport, IssueCategory } from '../../../models/Issue';
import { CATEGORIES } from '../../../rules/RulesEngine';
import { formatNumber } from '../../../utils/format';

export interface IHealthDashboardProps {
  report: IHealthReport;
  selected: IssueCategory | undefined;
  onSelect: (category: IssueCategory) => void;
}

/** One card per issue category; clicking a card shows its issues below. */
export default function HealthDashboard(props: IHealthDashboardProps): React.ReactElement {
  const { report, selected, onSelect } = props;
  const total: number = report.issues.length;

  return (
    <div>
      <h3 className={styles.sectionTitle}>
        Potential issues <span className={styles.sectionCount}>{formatNumber(total)}</span>
      </h3>
      <div className={styles.issueCards}>
        {CATEGORIES.map(info => {
          const count: number = report.byCategory[info.category].length;
          const classes: string[] = [styles.issueCard];
          if (count === 0) { classes.push(styles.issueCardClear); }
          if (selected === info.category) { classes.push(styles.issueCardSelected); }
          return (
            <button
              key={info.category}
              type="button"
              className={classes.join(' ')}
              onClick={() => onSelect(info.category)}
              disabled={count === 0}
              aria-pressed={selected === info.category}
              title={info.description}
            >
              <span className={styles.issueCardLabel}>{info.label}</span>
              <span className={styles.issueCardCount}>{formatNumber(count)}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
